import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {
  BUTTON_BLOCK_HEIGHT,
  BUTTON_BLOCK_WIDTH,
  FOOTER_LINE_HEIGHT,
  FOOTER_LINE_WIDTH,
  HERO_BLOCK_HEIGHT,
  TEXT_GROUP_LAST_LINE_WIDTH,
  TEXT_GROUP_ONE_LINE_COUNT,
  TEXT_GROUP_TWO_LINE_COUNT,
  TEXT_LINE_HEIGHT,
} from './canvas-loading-skeleton.types';
import styles from './canvas-loading-skeleton.module.scss';

export function CanvasLoadingSkeleton(): ReactElement {
  return (
    <div className={styles.overlay} aria-hidden>
      <div className={styles.page}>
        <SkeletonBrick height={HERO_BLOCK_HEIGHT} />
        {renderTextGroup(TEXT_GROUP_ONE_LINE_COUNT)}
        {renderTextGroup(TEXT_GROUP_TWO_LINE_COUNT)}
        <div className={styles.buttonRow}>
          <SkeletonBrick height={BUTTON_BLOCK_HEIGHT} width={BUTTON_BLOCK_WIDTH} />
        </div>
        <div className={styles.footerRow}>
          <SkeletonBrick height={FOOTER_LINE_HEIGHT} width={FOOTER_LINE_WIDTH} />
        </div>
      </div>
    </div>
  );
}

/** Renders a group of text lines; the last line is shorter so the group reads as a paragraph. */
function renderTextGroup(lineCount: number): ReactElement {
  return (
    <div className={styles.textGroup}>
      {Array.from({length: lineCount}, (_, i) => (
        <SkeletonBrick key={i} height={TEXT_LINE_HEIGHT} width={i === lineCount - 1 ? TEXT_GROUP_LAST_LINE_WIDTH : '100%'} />
      ))}
    </div>
  );
}
